// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface GcpNatGateway
 */
export interface GcpNatGateway {
  /**
   *
   * @type {number}
   * @memberof GcpNatGateway
   */
  portAllocation?: number;
}

/**
 * Check if a given object implements the GcpNatGateway interface.
 */
export function instanceOfGcpNatGateway(value: object): value is GcpNatGateway {
  return true;
}

export function GcpNatGatewayFromJSON(json: any): GcpNatGateway {
  return GcpNatGatewayFromJSONTyped(json, false);
}

export function GcpNatGatewayFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GcpNatGateway {
  if (json == null) {
    return json;
  }
  return {
    portAllocation:
      json['port_allocation'] == null ? undefined : json['port_allocation'],
  };
}

export function GcpNatGatewayToJSON(json: any): GcpNatGateway {
  return GcpNatGatewayToJSONTyped(json, false);
}

export function GcpNatGatewayToJSONTyped(
  value?: GcpNatGateway | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    port_allocation: value['portAllocation'],
  };
}
